/**
 * 選定解除企画商品情報削除VOクラス
 */
export class PlanGoodsModel {
  public orderCode = '';
  public mediumType = '';
}

export class DeletePlanGoodsInfoModel {
  public pCode = '';
  public planGoodsList: Array<PlanGoodsModel> = new Array<PlanGoodsModel>();
}
